// Map of all possible features for a user
export const ALL_FEATURE_TYPES_MAP = {
  Analytics: "Analytics",
  Inventory: "Inventory",
  Access: "Access",
  Settings: "Settings",
  Dashboard: "Dashboard",
  SALES_BY_DAY: "SALES_BY_DAY",
  SALE_AUDIT: "SALE_AUDIT",
  PAYMENTS_BY_DAYS: "PAYMENTS_BY_DAYS",
  BALANCE_BY_DAYS: "BALANCE_BY_DAYS",
  PREPAID_SUMMARY: "PREPAID_SUMMARY",
  ITEM_ACTIVITY: "ITEM_ACTIVITY",
  EXPORT_CHANGE_LOG: "EXPORT_CHANGE_LOG",
  APPROVE_PO: "APPROVE_PO",
  EDIT_APPROVED_PO: "EDIT_APPROVED_PO",
  POST_GRN: "POST_GRN",
  GRN_POST_FINAL_UPDATE: "GRN_POST_FINAL_UPDATE",
  POST_TRANSFER_OUT: "POST_TRANSFER_OUT",
  INVENTORY_DIRECT_BRANCH_TRANSFER: "INVENTORY_DIRECT_BRANCH_TRANSFER",
  INVENTORY_DIRECT_BRANCH_TRANSFER_RETURN:
    "INVENTORY_DIRECT_BRANCH_TRANSFER_RETURN",
  POST_TRANSFER_IN: "POST_TRANSFER_IN",
  CANCEL_TRANSFER_IN: "CANCEL_TRANSFER_IN",
  CANCEL_TRANSFER_RETURN_IN: "CANCEL_TRANSFER_RETURN_IN",
  POST_INDENT: "POST_INDENT",
  POST_AUDIT: "POST_AUDIT",
  POST_ADJUSTMENT: "POST_ADJUSTMENT",
  POST_SHRINKAGE: "POST_SHRINKAGE",
  POST_HOUSEMADE: "POST_HOUSEMADE",
  HOUSEMADE_BOM_OVERRIDE: "HOUSEMADE_BOM_OVERRIDE",
  HOUSEMADE_BOP_PRICE_OVERRIDE: "HOUSEMADE_BOP_PRICE_OVERRIDE",
  POST_PROCURE: "POST_PROCURE",
  POST_PURCHASE_RETURN: "POST_PURCHASE_RETURN",
  POST_TRANSFER_RETURN_OUT: "POST_TRANSFER_RETURN_OUT",
  POST_TRANSFER_RETURN_IN: "POST_TRANSFER_RETURN_IN",
  SUPPLIER_EDIT: "SUPPLIER_EDIT",
  CONTRACT_EDIT: "CONTRACT_EDIT",
  TRANSFER_RESOLUTION: "TRANSFER_RESOLUTION",
  VIEW_CURRENT_STOCK: "VIEW_CURRENT_STOCK",
  STOCK_SETTINGS_UPDATE: "STOCK_SETTINGS_UPDATE",
  SUBMIT_PAST_AUDIT: "SUBMIT_PAST_AUDIT",
  AUDIT_QUANTITY: "AUDIT_QUANTITY",
  AUDIT_PRICE: "AUDIT_PRICE",
  AUDIT_MULTIPLE_BRANCH: "AUDIT_MULTIPLE_BRANCH",
  SALES_EXPORT: "SALES_EXPORT",
  INVENTORY_EXPORT: "INVENTORY_EXPORT",
  TIN_ENTRY: "TIN_ENTRY",
  DAILY_CLOSING: "DAILY_CLOSING",
  ALLOW_MANUAL_ITEM_VERIFICATION: "ALLOW_MANUAL_ITEM_VERIFICATION",
  PRINT_BACKORDER: "PRINT_BACKORDER",
  INVOICE_REPRINT: "INVOICE_REPRINT",
  APPLY_DISCOUNT: "APPLY_DISCOUNT",
  OVERRIDE_DISCOUNT: "OVERRIDE_DISCOUNT",
  EDIT_SERVICE_TICKET: "EDIT_SERVICE_TICKET",
  SAVE_ORDER: "SAVE_ORDER",
  VOID_SALE: "VOID_SALE",
  CANCEL_SALE: "CANCEL_SALE",
  UNVOID_SALE: "UNVOID_SALE",
  UNCANCEL_SALE: "UNCANCEL_SALE",
  RETURN_SALE: "RETURN_SALE",
  MODIFY_PREPAID_BALANCE: "MODIFY_PREPAID_BALANCE",
  VIEW_OTHERS_ORDERS: "VIEW_OTHERS_ORDERS",
  VIEW_CLOSED_ORDERS: "VIEW_CLOSED_ORDERS",
  UPDATE_CLOSED_SALE: "UPDATE_CLOSED_SALE",
  EDIT_AFTER_PRINT: "EDIT_AFTER_PRINT",
  CLOSE_SALE_BALANCE: "CLOSE_SALE_BALANCE",
  CREATE_NEW_ORDER: "CREATE_NEW_ORDER",
  SOLD_OUT_ITEMS: "SOLD_OUT_ITEMS",
  NON_CHARGEABLE_SALE: "NON_CHARGEABLE_SALE",
  REPRINT_POST_SETTLEMENT: "REPRINT_POST_SETTLEMENT",
  EDIT_CHARGE: "EDIT_CHARGE",
  SPLIT_PAYMENTS: "SPLIT_PAYMENTS",
  BILL_SETTLEMENT: "BILL_SETTLEMENT",
  SEND_DIGITAL_BILL: "SEND_DIGITAL_BILL",
  TRANSFER_ITEMS: "TRANSFER_ITEMS",
  OPEN_ORDER_PRINT: "OPEN_ORDER_PRINT",
  MANAGE_PRINTERS: "MANAGE_PRINTERS",
  POS_PREFERENCES: "POS_PREFERENCES",
  PARTIAL_BATCH_VERIFICATION: "PARTIAL_BATCH_VERIFICATION",
  OVERRIDE_BATCH_SELECTION_IN_POS: "OVERRIDE_BATCH_SELECTION_IN_POS",
  MANAGE_RISTACARDS: "MANAGE_RISTACARDS",
  AGGREGATOR_OUTLET_UPDATE: "AGGREGATOR_OUTLET_UPDATE",
  CUSTOMER_EDIT: "CUSTOMER_EDIT",
  MENU_SYNC: "MENU_SYNC",
  VIEW_FEEDBACK_RESPONSE: "VIEW_FEEDBACK_RESPONSE",
  ALLOW_MEMBERSHIP_UPDATE: "ALLOW_MEMBERSHIP_UPDATE",
  VIEW_STOCK_RATES: "VIEW_STOCK_RATES",
  VIEW_PRODUCTION_ACTIVITY_RATES: "VIEW_PRODUCTION_ACTIVITY_RATES",
  VIEW_ADJUSTMENT_ACTIVITY_RATES: "VIEW_ADJUSTMENT_ACTIVITY_RATES",
  VIEW_TRANSFER_ACTIVITY_RATES: "VIEW_TRANSFER_ACTIVITY_RATES",
  VIEW_PURCHASE_ACTIVITY_RATES: "VIEW_PURCHASE_ACTIVITY_RATES",
  MANAGE_INVENTORY_ACTIVITY: "MANAGE_INVENTORY_ACTIVITY",
  MANAGE_SUPPLIERS: "MANAGE_SUPPLIERS",
  MANAGE_CONTRACTS: "MANAGE_CONTRACTS",
  ALLOW_RISTACARDS_REFUND: "ALLOW_RISTACARDS_REFUND",
  ALLOW_RISTACARDS_VIEW_BALANCE_IN_LIST:
    "ALLOW_RISTACARDS_VIEW_BALANCE_IN_LIST",
  ALLOW_MANUAL_BATCH_VERIFICATION: "ALLOW_MANUAL_BATCH_VERIFICATION",
  REJECT_PENDING_RESOLUTION: "REJECT_PENDING_RESOLUTION",
  RESOLVE_REJECTED_ACTIVITY: "RESOLVE_REJECTED_ACTIVITY",
  ALLOW_TRANSFER_OUT_FOR_INCOMPLETE_INDENT:
    "ALLOW_TRANSFER_OUT_FOR_INCOMPLETE_INDENT",
  PO_PRICE_OVERRIDE: "PO_PRICE_OVERRIDE",
  GRN_PRICE_OVERRIDE: "GRN_PRICE_OVERRIDE",
  GRN_PREVENT_HIGHER_QUANTITY: "GRN_PREVENT_HIGHER_QUANTITY",
  MANUAL_BRANCH_CLOSE: "MANUAL_BRANCH_CLOSE",
  ALLOW_VIDEO_ATTACHMENT_IN_SHRINKAGE: "ALLOW_VIDEO_ATTACHMENT_IN_SHRINKAGE",
  MANAGE_RESOURCE : "MANAGE_RESOURCE",
  ALLOW_DOWNLOAD_XML_LEDGER_REPORT : "ALLOW_DOWNLOAD_XML_LEDGER_REPORT",
  FRANCHISE_INVOICE_REPORTS : "FRANCHISE_INVOICE_REPORTS",
  ALLOW_EDIT_XML_LEDGER_MAPPING: "ALLOW_EDIT_XML_LEDGER_MAPPING",
} as const;
type FeatureKeys = keyof typeof ALL_FEATURE_TYPES_MAP;
export type Feature = (typeof ALL_FEATURE_TYPES_MAP)[FeatureKeys]


export enum Licences {
  AALT = "AALT",
  RECON = "RECON"
};